import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Container from './containers/Container'
import MapContainer from './containers/MapContainer'
import getPath from '../../shared/utils/getPath'

const mapRoutes = (
  <Route
    component={Container}
    key="map-routes"
    path={getPath('frontend', 'map')}
  >
    <IndexRoute component={MapContainer} />
  </Route>
)

export default mapRoutes



// WEBPACK FOOTER //
// ./src/frontend/map/routes.js